import React, {PureComponent} from 'react'
import cn from "classnames"
import injectSheet from 'react-jss'
import ImageOrVideo from "../Widgets/ImageOrVideo"
import Caption from "../Widgets/Caption"
import Quote from "../Widgets/Quote"
import theme from "../../styles/theme"
import ShopTheLookLink from "../ShopThLook/ShopTheLookLink"

class FullWidthImageWithQuote extends PureComponent {

    render() {
        const {classes, classNames = {}, item} = this.props;
        const {image, video, link, quote, quote_attribution, caption, shop_the_look_title, shopItems, quote_location_horizontal} = item;
        const hasShopItems = shopItems && shopItems.length > 0;
        const shopTheLookImage = hasShopItems && ((image && image.desktop) || (video && video.image.desktop))

        return (
            <section className={cn(classes.fullWidthContainer, classNames.fullWidthContainer)}>
                {caption && <Caption key="caption" className={cn(classes.caption, classes.captionTop)} caption={caption}></Caption>}
                <ImageOrVideo images={image} video={video} link={!hasShopItems && link}>
                    {hasShopItems && <ShopTheLookLink title={shop_the_look_title} shopItems={shopItems} image={{desktop: shopTheLookImage}} horizontalPosition={quote_location_horizontal} />}
                </ImageOrVideo>
                <div className={classes.container}>
                    {quote && <Quote key="quote" className={classes.quoteContainer} bodyClassName={classes.quoteBody} quote={quote} quote_attribution={quote_attribution} imageQuote={true}/> }
                    {quote && <Caption key="caption" className={cn(classes.caption, classes.captionBottom)} caption={caption}></Caption>}
                </div>
            </section>
        )
    }
}

const getHorizontalFlexDirection = (location) => {
    switch( location ) {
        case "Right":
            return "row-reverse"
        default:
            return "row";
    }
}

export default injectSheet(
    {
        fullWidthContainer: {
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
            padding: ({item: {image_size}}) => image_size === '100%' ? 0 : `0 ${theme.spacing.small}`,
            [theme.breakpoint('tablet')]: {
                padding: [0, theme.spacing.normal],
                maxWidth: '100%'
            },
            [theme.breakpoint('laptop')]: {
                maxWidth: ({item: {image_size}}) => image_size ? image_size : '100%'
            },
        },
        container: {
            height: 0,
            display: "flex",
            flexDirection: ({item:{quote_location_horizontal}}) => getHorizontalFlexDirection(quote_location_horizontal),
            justifyContent: "flex-start",
            [theme.breakpoint("tablet")]: {
                justifyContent: "space-around",
            }
        },
        quoteContainer: {
            boxSizing: "content-box",
            flexBasis: "100%",
            height: "100%",
            position: "relative",
            marginRight: theme.spacing.small,
            [theme.breakpoint("tablet")]: {
                flexBasis: "50%",
            }
        },
        quoteBody: {
            position: "absolute",
            bottom: 0,
            margin: 0,
            maxWidth: 480,
            [theme.breakpoint("tablet")]: {
                bottom: `-${theme.spacing.small}`,
            }
        },
        caption: {
            maxWidth: 360
        },
        captionTop: {
            display: "block",
            marginLeft: theme.spacing.small,
            marginRight: theme.spacing.small,
            [theme.breakpoint("tablet")]: {
                display: "none"
            }
        },
        captionBottom: {
            display: "none",
            [theme.breakpoint("tablet")]: {
                display: "block"
            }
        }
    }
)(FullWidthImageWithQuote)





// WEBPACK FOOTER //
// ./src/components/Article/FullWidthImageWithQuote.js